import { useCallback, useEffect, useState } from 'react'

type Query = { min: number } | { max: number }

export const useMediaQuery = (query: Query) => {
  const [targetReached, setTargetReached] = useState(false)

  const updateTarget = useCallback((e: { matches: any }) => {
    if (e.matches) {
      setTargetReached(true)
    } else {
      setTargetReached(false)
    }
  }, [])

  useEffect(() => {
    const [key, width] = Object.entries(query)[0]
    const media = window.matchMedia(`(${key}-width: ${width}px)`)
    media.addListener(updateTarget)

    // Check on mount (callback is not called until a change occurs)
    if (media.matches) {
      setTargetReached(true)
    }

    return () => {
      media.removeListener(updateTarget)
    }
  }, [])

  return targetReached
}
